import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "column" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = {
    key: 0,
    class: "label"
};
const _hoisted_4 = {
    key: 0,
    class: "mb-2"
};
const _hoisted_5 = { class: "checkbox" };
const _hoisted_6 = ["checked", "disabled"];
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormCheckboxField',
    props: {
        modelValue: { type: Boolean },
        label: {},
        description: {},
        boxLabel: {},
        validator: { type: Function },
        validationId: {},
        isDisabled: { type: Boolean }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // The input element where the form field's value will be bound
        const inputElem = ref(null);
        // Event for two-way binding
        const onInput = () => {
            emit('update:modelValue', inputElem.value.checked);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.label)
                        ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_ctx.label), 1))
                        : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "top")
                ]),
                (_ctx.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("label", _hoisted_5, [
                    _createElementVNode("input", {
                        ref_key: "inputElem",
                        ref: inputElem,
                        type: "checkbox",
                        class: _normalizeClass(["mr-3", { 'is-danger': _ctx.validator ? !_ctx.validator(_ctx.validationId ? _ctx.validationId : this, _ctx.modelValue) : false }]),
                        checked: _ctx.modelValue,
                        onChange: _cache[0] || (_cache[0] = ($event) => (onInput())),
                        disabled: _ctx.isDisabled
                    }, null, 42, _hoisted_6),
                    _createTextVNode(" " + _toDisplayString(_ctx.boxLabel), 1)
                ]),
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
